import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { TextInput } from '@rentspree/component-2023.components.atoms.text-input';

import { MapPlaceholder } from '../atoms/MapPlaceholder';

export interface AddressInputProps {
  value: string;
  onChange: (value: string) => void;
  onValidationChange?: (isValid: boolean) => void | undefined;
  onKeyPress?: (event: React.KeyboardEvent) => void | undefined;
  placeholder?: string | undefined;
  autoFocus?: boolean | undefined;
  disabled?: boolean | undefined;
  showMap?: boolean | undefined;
  className?: string | undefined;
}

export const AddressInput: React.FC<AddressInputProps> = ({
  value,
  onChange,
  onValidationChange,
  onKeyPress,
  placeholder = 'Enter your address',
  autoFocus = false,
  disabled = false,
  showMap = true,
  className,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  useEffect(() => {
    const valid = value.trim().length > 0;
    if (onValidationChange) {
      onValidationChange(valid);
    }
  }, [value, onValidationChange]);

  return (
    <Box
      className={className}
      sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
    >
      <TextInput
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onKeyPress={onKeyPress}
        fullWidth
        autoFocus={autoFocus}
        disabled={disabled}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#FFFFFF',
            height: '56px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#110000',
              borderWidth: '1px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#9CA3AF',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#E5E7EB',
            },
            '& .MuiOutlinedInput-input': {
              fontSize: '16px',
              padding: '16px 14px',
              color: '#111827',
              '&::placeholder': {
                color: '#9CA3AF',
                opacity: 1,
              },
            },
          },
        }}
      />

      {showMap && <MapPlaceholder />}
    </Box>
  );
};
